import { Api, ApiResponse } from "common";
import { GetUserRMAPayload, GetUserRmaResponse } from "./types";

const getPcwCareDetails = (
  data: GetUserRMAPayload
): ApiResponse<GetUserRmaResponse> => {
  const params = new URLSearchParams(data as Record<string, string>).toString();
  return Api.get(`/api/rma/ecomm/get?${params}`);
};

export const UserRmaApi = {
  getPcwCareDetails,
};
